// extracted by mini-css-extract-plugin
export var lFooter = "sp1ab";
export var lFooter__inner = "sp1bb";
export var lFooter__title = "sp1cb";
export var lFooter__sns = "sp1db";
export var lFooter__menu = "sp1eb";
export var lFooter__copyright = "sp1fb";
export var animationMarquee = "sp1gb";